export enum BasketballTurnoverAttribute {
  OutOfBounds = 508,
  Travelling = 509,
  ShotClock = 510,
  Backcourt = 511,
  EightSeconds = 512,
  FiveSeconds = 513,
  ThreeSeconds = 514,
  DoubleDribble = 515,
  OffensiveGoaltending = 516,
}
